import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectBudgetComparison from '@app/views/ProjectBudgetComparison';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectBudgetComparison)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
